module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bhead"
  }, [_c('span', [_vm._v("2")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("Y THE TIME the sun had come up and burned off the river mist, everyone who had seen the body in the daylight knew that this was no medical school prank. The Home Office duty pathologist, Harsha Krishnamurthi, arrived and disappeared for an hour inside the white Incitent. A fingertip search team was corralled and instructed, and by noon the body was being freed from under the concrete.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery found Maddox in the front seat of B team’s Sierra.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There’s nothing more we can do here, mate. We’ll let Krishnamurthi take over from here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Go home, get some kip.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No. I’ll stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, Jack. You too. If you want an exercise in insomnia you’ll get it in the next few days. Trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery held his hand up. “Okay, okay. Whatever you say. Sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Whatever I say.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But I won’t sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Fine. That’s fine. Go home.” He gestured to Caffery’s battered old Jaguar. “Go home and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pretend")]), _vm._v(" to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The image of the rich-yellow body under the tent kept pace with Caffery, even when he got home. In the new whitish light she seemed more real than she had last night. Her nails, bitten and painted sky blue, curled inward to the swollen palms.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He showered, shaved. His face in the mirror was tanned from a morning near the river; there were new sun crinkles around his eyes. He knew he wouldn’t sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The accelerated promotion of new blood in the Area Major Investigation Pool: younger, harder, fitter, he recognized the resentment coming from the lower ranks and understood the small, grim pleasure they took when the eight-week standby rota circled back to B team, coinciding neatly and nastily with his first case duty.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Seven days, twenty-four-hour standby, wakeful nights: and slam straight into the case, no time to catch a breath. He wouldn’t be at his best.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And it was looking like a complex one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It wasn’t only the location and lack of witnesses that muddied it; in the morning light they had seen the black ulcerated marks of needle tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And the offender had done something to the victim’s breasts that Caffery didn’t want to think about here in his white-tiled bathroom. He toweled his hair and shook his head to free the water in his ears. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stop thinking about it, now. Stop letting it chase its tail round your head")]), _vm._v(". Maddox was right, he needed to rest.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He was in the kitchen, pouring a Glenmorangie, when the doorbell rang.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s me,” Veronica called through the letter box. “I’d’ve phoned but I left my mobile at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He opened the door. She wore a cream linen suit and Armani sunglasses tucked in her hair. Shopping bags from Chelsea boutiques clustered around her ankles. Her postbox-red Tigra convertible was parked in the evening sun beyond the garden gate and Caffery saw she was holding his front door key as if she had been on the point of letting herself in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hello, sexy.” She leaned in for a kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He kissed her, tasting lipstick and menthol breath spray.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mmmmm!” She held his wrist and drew back, taking in the morning’s suntan, the jeans, the bare feet. The bottle of whisky dangling between his fingers. “Relaxing, were you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I was in the garden.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Watching Penderecki?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You think I can’t go in the garden without watching Penderecki?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course you can’t.” She started to laugh, then saw his face. “Oh, come on, Jack. I’m "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("joking")]), _vm._v(". Here.” She picked up a Waitrose carrier bag and handed it to him. “I’ve been shopping—prawns, fresh dill, fresh coriander and, oh, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("best")]), _vm._v(" muscatel. And this—” She held up a dark green box. “From Dad and me.” She raised one long leg like an exotic bird and rested the box against her knee to open it. A brown leather jacket nestled in printed tissue. “One of the lines we import.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ve got a leather jacket.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh.” Her smile faltered. “Oh. Okay. Not to worry.” She closed the box. They were both silent for a moment. “I can take it back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No.” Jack was instantly ashamed. “Don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Honestly. I can swap it from stock.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, really. Here, give it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This, he thought, kneeing the front door closed and following her into the house, was the Veronica pattern. She made a life-altering suggestion, he rebutted it, she pushed out her lower lip, bravely shrugged her shoulders, and immediately he became guilty, rolled onto his back and capitulated. Because of her past. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Simple but effective, Veronica")]), _vm._v(". In the six short months they’d known each other, his worn, comfortable home had been transformed into something unfamiliar, crammed with scented plants and labor-saving gadgets, his wardrobe bulging with clothes he would never wear: designer suits, hand-stitched jackets, silk ties, moleskin jeans, all courtesy of her father’s Mortimer Street importing company.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Now, as Veronica made herself at home in his kitchen—the windows open, the Guzzini buzzing, peanut oil sizzling in bright green pans—Jack took the whisky onto the terrace.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("The garden. Now there, he thought, unstoppering the Glen-morangie, there was perfect proof that the relationship was on a tilt. Planted long before his parents had bought the house—full of hibiscus, Russell lupins, a gnarled, ancient clematis—he liked to let it grow each summer until it almost blocked the windows with")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v(" green. But Veronica wanted to trim, prune and fertilize, to grow lemongrass and capers in painted pots on the windowsills, make garden plans, talk gravel paths and bay trees. And ultimately—once she’d repackaged him and his house—she’d like him to sell up, leave this, the little South London, crumbly-brick Victorian cottage he was born in, with its mullioned windows, its tangled garden, the trains rattling by in the distance. She wanted to give up her token job in the family business, move out of her parents’ and get started on making a home for him.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("But he couldn’t. His history was embedded too deeply in this quarter acre of loam and clay to pull it out on a whim. And after six months of knowing Veronica, he was sure of one thing: he didn’t love her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He watched her through the window now, scrubbing potatoes, making butter curls. At the end of last year he had been four years in CID and slacking—treading water, bored, waiting for the next thing. Until, at an out-of-control CID Halloween party, he realized that wherever he turned, a girl in a miniskirt and strappy gold sandals was watching him, a knowing smile on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Veronica triggered in Jack a two-month-long hormonal obsession. She matched his sex drive. She woke him at 6:00 each morning for sex and spent the weekends wandering around the house in nothing but heels and sorbet-bright lipstick.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She gave him new energy, and other areas of his life began to change. By April he had Manolo Blahnik kitten-heel marks in his headboard and a transfer to AMIP. The murder squad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But in spring, just as his drive toward her faltered, Veronica’s agenda swerved. She became serious about him, started a campaign to tether him to her. One night she sat him down and in serious tones told him about the big injustice in her life, long before they had met: two of her teenage years taken from her by a struggle against cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The ploy worked. Brought up short, suddenly he didn’t know how to finish with her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How arrogant, Jack")]), _vm._v(", he realized, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("as if you not leaving might be compensation. How arrogant can you get.")])])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("In the kitchen she tucked her thin, asymmetric chin down onto")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" her chest, her tongue between her teeth, and ripped a sprig of mint into shreds. He poured a shot of whisky and swallowed it in one.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Tonight he would do it. Maybe over dinner—")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("It was ready in an hour. Veronica switched all the lights on in the house and lit citronella garden candles on the patio.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Pancetta and broad-bean salad with rocket, prawns in honey and soy sauce, followed by clementine sorbet. Am I the perfect woman or what?” She shook her hair and briefly exposed expensively cared-for teeth. “Thought I’d try it out on you and see if it’ll do for the party.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The party.” He’d forgotten. They’d arranged it when they thought that ten days after standby week was a good, quiet time to throw a party.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lucky "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" haven’t forgotten, isn’t it?” She pushed past him, carrying the Le Creuset piled with baby new potatoes. In the living room the French windows were open onto the garden. “We’re eating in here tonight, no point in opening the dining room.” She stopped, looking at his crumpled T-shirt, the dark feral hair. “Do you think you should dress for dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" joking.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, I—” She unfolded a napkin on her lap. “I think it’d be nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No.” He sat down. “I need my suit. My case has started.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go on, ask me about the case, Veronica, show an interest in something other than my wardrobe, my table linen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But she started pushing potatoes onto his plate. “You’ve got more than one suit, haven’t you? Dad sent you that gray one.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The others’re at the cleaner’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, Jack, you should have said. I could have picked them up.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Veronica—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay.” She held her hand up. “I’m sorry. I won’t mention it again—” She broke off. In the hallway the phone was ringing. “I wonder who that is.” She speared a potato. “As if I couldn’t guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery put his glass down and pushed his chair back.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“God,” she sighed, exasperated, putting the fork down.")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" “They’ve got a sixth sense, they really have. Can’t you just let it ring?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the hallway he picked up the phone. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t tell me. You were asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I told you I wouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sorry to do this to you, mate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah, what’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m back down here. The governor’s okayed bringing in some equipment. One of the search team found something.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Equipment?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“GPR.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“GPR? That’s—” Caffery broke off. Veronica pushed past him and walked purposefully up the stairs, closing the bedroom door behind her. He stood in the narrow hallway staring after her, one hand propped up against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You there, Jack?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah, sorry. What were you saying? GPR, that’s ground-probing something?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ground-probing radar.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay. What you’re telling me is—” Caffery dug a small niche in the wall with his black thumbnail. “You’re telling me you’ve got more?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ve got more.” Maddox was solemn. “Four more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Shit.” He massaged his neck. “In at the deep end or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They’ve started on the recovery now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay. Where’ll you be?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“At the yard. We can follow them down to Devonshire Drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The mortuary? Greenwich?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Uh-huh. Krishnamurthi’s already started with the first one. He’s agreed to do an all-nighter for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay. I’ll see you there in thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Upstairs, Veronica was in the bedroom with the door shut. Caffery dressed in Ewan’s room, checked once out of the window for activity over the railway at Penderecki’s—nothing—and, doing up his tie, put his head around the bedroom door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right. We’re going to talk. When I get back—”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He stopped. She was sitting in bed, the covers pulled up to her neck, clutching a bottle of pills.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She looked up at him. Bruised, sullen eyes. “Ibuprofen. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What are you doing, Veronica?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My throat’s up again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stopped, the tie extended in his left hand. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Your throat’s up?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That’s what I said.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Since when?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, either your throat’s up or it isn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She muttered something under her breath, opened the bottle, shook two pills into her hand and looked up at him. “Going somewhere nice?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why didn’t you tell me your throat was up? Shouldn’t you be having tests?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t worry about it. You’ve got more important things to think about.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Veronica—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was silent for a moment. “Nothing.” He finished knotting the tie and turned for the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t worry about me, will you?” she called after him. “I won’t wait up.”")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-983fa8f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch_02.vue
// module id = 81
// module chunks = 0